import React from "react";
import Tabla from "js/components/TablaPuntoDeVenta";

export const PuntoDeVenta = props => {
  return (
    <div>
      <Tabla />
    </div>
  );
};

export default PuntoDeVenta;
